import { render } from "./Checkboard.vue?vue&type=template&id=0a544b87&scoped=true&ts=true"
import script from "./Checkboard.vue?vue&type=script&lang=ts"
export * from "./Checkboard.vue?vue&type=script&lang=ts"

import "./Checkboard.vue?vue&type=style&index=0&id=0a544b87&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a544b87"]])

export default __exports__